import papa from "../../pics/papa.png";
import mama from "../../pics/mama.jpg";

export default function About() {
  return (
    <div className="p-6 md:p-10 flex flex-col md:flex-row md:items-start bg-stone-200 min-h-screen">
      {/* Images container */}
      <div className="w-full md:w-1/2 flex flex-col items-center gap-4">
        <img
          src={mama}
          alt="mama"
          className="w-10/12 max-w-md object-cover rounded-lg shadow-md"
        />
        <img
          src={papa}
          alt="papa"
          className="w-10/12 max-w-md object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Text container */}
      <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-10">
        <p className="text-lg md:text-2xl font-thin text-justify">
          Taking pictures is exiting. For thousands of years mankind experienced stress and satisfaction in hunting and gathering. When we are out with our cameras the basic feelings are not so different. If the desired animal shows up we may have only a couple of seconds to realize the optimal shot, given the light is perfect and the right lens is in place. To master the technology of the camera equipment combined with the unpredictability of nature is appealing and rewarding. We always respect nature and rather refrain from taking the photo if we might disturb an animal.
          As Ansel Adams and Alfred Stieglitz put it in 1933;
          „I have the desire to photograph. I go out with my camera. I come across something that excites me emotionally, spiritually, aesthetically. I see the photograph in my mind`s eye and I compose and expose the negative. I give you the print as the equivalent of what I saw and felt.
          As with all art, the photographer`s objective is not the duplication of visual reality. Photographic images cannot avoid being accurate optically, as lenses are used. However, they depart from reality in direct relation to the placement of the camera before the subject, the lens choosen, the film and filters, the exposure indicated, the related development and printing; all of course, relating to what the photographer visualizes.“
        </p>
      </div>
    </div>
  );
}
